import { Dispatch } from 'redux'
import {
  set as setAction,
  update as updateAction
} from 'states/dux/layout/actions'
import { Action } from 'states/types'
import { NivosLayout } from 'types/layout'

type DispatchAction = (dispatch: Dispatch) => Action<NivosLayout>

const set = (layout: NivosLayout): DispatchAction => {
  return (dispatch: Dispatch): Action<NivosLayout> =>
    dispatch(setAction(layout))
}

const update = (layout: Partial<NivosLayout>): DispatchAction => {
  return (dispatch: Dispatch): Action<NivosLayout> =>
    dispatch(updateAction(layout))
}

export interface Operations {
  set: (layout: NivosLayout) => DispatchAction
  update: (layout: Partial<NivosLayout>) => DispatchAction
}

const operations: Operations = {
  set,
  update
}

export { operations, set, update }
